import { getField } from 'vuex-map-fields';

export const getters = {
  getField,

  getBusinessRuleTable: (state) => (UUID) =>
    state.businessRules.find((businessRule) => businessRule.UUID === UUID).DataTableName,

  getColumnList:
    (state) =>
    (includeKPI = true) => {
      let updatedKpi = [];
      // For group by kpis not required.
      if (includeKPI) {
        updatedKpi = state.kpis.map((kpi) => `KPI:${kpi.Title}`);
      }
      const fieldsData = state.businessRuleFieldsMap[state.widget.BusinessRuleRef] || state.businessRuleColumn;
      const columnNames = fieldsData.map((column) => column.name);
      let data = [...columnNames, ...updatedKpi];
      // Get details of current business rule.
      let businessRuleDetails = state.businessRules.find(
        (businessRule) => businessRule.UUID === state.widget.BusinessRuleRef
      );
      // Add column if workflow is defined.
      if (businessRuleDetails && businessRuleDetails.WorkflowUUID) {
        data.push('WorkflowState');
        data.push('workflowState_assignee');
      }
      return data;
    },

  selectedKpis: (state) => () => state.widget.Series.map(({ KpiRef }) => KpiRef),

  selectedFieldValues: (state) => () => state.widget.Settings.ganttChartColorsMap.map(({ colValue }) => colValue),

  getGroupByFieldsForChart: (state) => () => {
    let columns = state.businessRuleFieldsMap[state.widget.BusinessRuleRef] || state.businessRuleColumn;
    columns = columns.map((column) => {
      column.id = column.name;
      return column;
    });
    const dateColumns = columns.filter((column) => ['date', 'datetime', 'datetime2'].includes(column.type));
    dateColumns.forEach((field) => {
      columns = columns.concat([
        {
          name: field.name + ' (Day)',
          id: field.name + '~@~Date',
          type: 'nvarchar'
        },
        {
          name: field.name + ' (Week)',
          id: field.name + '~@~Week',
          type: 'nvarchar'
        },
        {
          name: field.name + ' (Month)',
          id: field.name + '~@~Month',
          type: 'nvarchar'
        },
        {
          name: field.name + ' (Quarter)',
          id: field.name + '~@~Quarter',
          type: 'nvarchar'
        },
        {
          name: field.name + ' (Year)',
          id: field.name + '~@~Year',
          type: 'nvarchar'
        }
      ]);
    });
    return columns;
  },

  // Get cofiguration tabs
  getTabs: (state) => {
    if (state.widget.Settings.enableAdvancedSettings) {
      return ['general', 'advanced'];
    }
    return ['general'];
  }
};
